<template>
  <base-modal>
    <p class="mb-2">{{ $t('pbx.time-condition.modal.add_interval.days') }}</p>

    <div class="d-flex justify-content-between">
      <i-button
        v-for="(title, key) in $t('shared.unit.day')"
        :key="key"
        :ghost="!days[key]"
        type="primary"
        @click="days[key] = !days[key]"
      >
        {{ title.short }}
      </i-button>
    </div>

    <p class="mt-3 mb-2">{{ $t('pbx.time-condition.modal.add_interval.worktime') }}</p>
    <div class="row align-items-center">
      <div class="col-4">
        <time-input v-model="start" size="large" />
      </div>
      <div class="col-4 text-center">&mdash;</div>
      <div class="col-4">
        <time-input v-model="end" size="large" />
      </div>
    </div>

    <i-button slot="footer-ok" size="large" type="success" :disabled="is_disable" @click="save">
      {{ $t('shared.component.button.save') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import TimeInput from '@shared/components/input/input-time-block';
  import { getUID } from '@shared/helpers/uid';
  import pickBy from 'lodash-es/pickBy';

  export default {
    components: {
      BaseModal,
      TimeInput
    },

    data: () => ({
      contentLoading: false,
      days: {
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
        sat: false,
        sun: false
      },

      start: '',
      end: ''
    }),

    computed: {
      is_disable: function() {
        return Object.values(this.days).every(i => i === false);
      }
    },

    methods: {
      save: function() {
        const checked_items = pickBy(this.days, i => i === true);
        const items = Object.keys(checked_items).map(d => ({
          id: getUID(),
          day: d,
          start: this.start,
          end: this.end
        }));

        this.$emit('success', items);
      }
    }
  };
</script>
